export const wishlistFn = () => {
  const wishlist = document.querySelector(".navbar-wishlist__count");
  if (wishlist) {
    jQuery(function($) {
      $(document).on('added_to_wishlist removed_from_wishlist', function() {
        $.ajax({
          url: yith_wcwl_l10n.ajax_url,
          type: 'POST',
          data: {
            action: 'yith_wcwl_update_wishlist_count'
          },
          success: function(response) {
            $('#wishlist-count').text(response.count);
          }
        });
      });
    });
  }
};
